import { Transform as n } from "../transforms/components.js";
import "bitecs";
import "../../core/ecs/components.js";
import * as u from "three";
import "../../core/validation/schemas.js";
import "../transforms/systems.js";
import { syncEulerFromQuaternion as i } from "../transforms/utils.js";
import { OrbitCamera as r } from "./components.js";
import { smoothLerp as f, shortestAngleDiff as l, normalizeAngle as w } from "./math.js";
function d(o, t) {
  const e = f(
    r.smoothness[o],
    t
  ), s = l(
    r.currentYaw[o],
    r.targetYaw[o]
  );
  r.currentYaw[o] += s * e, r.currentYaw[o] = w(
    r.currentYaw[o]
  ), r.currentPitch[o] += (r.targetPitch[o] - r.currentPitch[o]) * e, r.currentDistance[o] += (r.targetDistance[o] - r.currentDistance[o]) * e;
}
function C(o, t) {
  const e = r.currentDistance[o], s = r.currentYaw[o], p = Math.PI / 2 - r.currentPitch[o], c = new u.Spherical(e, p, s);
  return new u.Vector3().setFromSpherical(c).add(t);
}
function F(o, t, e) {
  n.posX[o] = t.x, n.posY[o] = t.y, n.posZ[o] = t.z;
  const s = new u.Matrix4();
  s.lookAt(t, e, new u.Vector3(0, 1, 0));
  const p = new u.Quaternion().setFromRotationMatrix(
    s
  );
  n.rotX[o] = p.x, n.rotY[o] = p.y, n.rotZ[o] = p.z, n.rotW[o] = p.w, i(n, o);
}
export {
  C as calculateCameraPosition,
  d as smoothCameraRotation,
  F as updateCameraTransform
};
//# sourceMappingURL=operations.js.map
